import type { Components, Theme } from '@mui/material/styles';

export const MuiAccordion: Components<Theme>['MuiAccordion'] = {
  styleOverrides: {
    root: ({ theme: { palette, shape, spacing } }) => ({
      '&': {
        backgroundColor: palette.neutral[0],
        borderRadius: shape.borderRadius,
        padding: spacing(1.5, 1),
        boxShadow: 'none',

        '&.Mui-expanded': {
          backgroundColor: palette.neutral[0],
          margin: 0,
        },

        '&:before': {
          content: 'none',
        },

        '&.Mui-disabled': {
          backgroundColor: 'transparent',
        },
      },
    }),
  },
};
